/* eslint-disable @typescript-eslint/no-unused-vars *//* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import {Link} from 'react-router-dom';

import {
  MDBSideNav,
  MDBSideNavMenu,
  MDBSideNavItem,
  MDBSideNavLink,
  MDBSideNavCollapse,
  MDBIcon
} from 'mdb-react-ui-kit';

import React, { useState } from 'react';

import logo from "../assets/img/logoSI.webp"
  
import "../style/css/menu.css"
  
function Menu(){
  const [collapseOpened, setCollapseOpened] = useState('');
  const [collapseOpened2, setCollapseOpened2] = useState('');
  const [basicOpen, setBasicOpen] = useState(true);
  const [selectedItem, setSelectedItem] = useState<string>(''); // État pour suivre l'élément sélectionné

    const handleClick1 = () => {
      window.location.href='/dashboard'
    }
    const handleClick2 =() => {
      window.location.href='/inventaire/utilisateurs'
    }
    const handleClick3 = () => {
      window.location.href="/configuration/globale"
    }
    const handleClick4 = () => {
      window.location.href ="/configuration/documents/categories"
    }
    const toggleAccordion = (value: string) => {
        value !== collapseOpened ? setCollapseOpened(value) : setCollapseOpened('');
      };

    const toggleAccordion2 = (value: string) => {
        value !== collapseOpened2 ? setCollapseOpened2(value) : setCollapseOpened2('');
    };
    const handleItemClick = (itemId: string) => {
        setSelectedItem(itemId);
      };

    return (
   
      <div className="menu">
   
        <MDBSideNav mode='side' open={basicOpen} getOpenState={setBasicOpen}> 
          
          <div className="menu">
            
            <div className="">
          
              <div className='d-flex justify-content-center py-4'>
            <Link to="/dashboard">
              <img
                id='MDB-logo'
                src={logo}
                alt='MDB Logo'
                draggable='false'
              />
            </Link>
              </div>

              <MDBSideNavMenu>

                <MDBSideNavItem onClick={handleClick1}>

                  <MDBSideNavLink>

                    <MDBIcon  icon='home' className='fa-fw me-3' color="dark" />

                    <p className="textItem" id="dashboardmenu"> Dashboard </p>

                  </MDBSideNavLink>

                </MDBSideNavItem>

                <MDBSideNavItem>

                  <MDBSideNavLink
                  icon='angle-down'
                  shouldBeExpanded={collapseOpened === 'accordionCollapse'}
                  onClick={() => toggleAccordion('accordionCollapse')}>

                  <MDBIcon icon='cogs' className='fa-fw me-3' color="dark" />

                  <p className="textItem">Inventaire</p>

                  </MDBSideNavLink>

                  <MDBSideNavCollapse
                    id='accordionCollapse'
                    open={collapseOpened === 'accordionCollapse'}>

                    <MDBSideNavLink 
                      onClick={() => { handleItemClick('Users')
                      handleClick2()}}  
                      id={collapseOpened === 'accordionCollapse' ? 'blue-text' : ''}  
                      className={selectedItem === 'Users' ? 'blue-background' : ''}>
                    
                      <p className="textLItem">Utilisateurs</p>
                    
                    </MDBSideNavLink>
            
                  </MDBSideNavCollapse>

                </MDBSideNavItem>

                <MDBSideNavItem>

                  <MDBSideNavLink
                    icon='angle-down'
                    shouldBeExpanded={collapseOpened2 === 'accordionCollapse2'}
                    onClick={() => toggleAccordion2('accordionCollapse2')} >

                  <MDBIcon icon='laptop' className='fa-fw me-3' color="dark" />

                  <p className="textItem">Configuration</p>
                
                </MDBSideNavLink>

              <MDBSideNavCollapse
                id='accordionCollapse2'
                open={collapseOpened2 === 'accordionCollapse2'}>
               
                <MDBSideNavLink 
              onClick={() => { handleItemClick('Global')
              handleClick3()}}  
              id={collapseOpened2 === 'accordionCollapse2' ? 'blue-text' : ''}  
              className={selectedItem === 'Global' ? 'blue-background' : ''}>

                <p className="textLItem">Générale</p>

                </MDBSideNavLink> 

                <MDBSideNavLink onClick={() =>{ handleItemClick('Documents')
              handleClick4()}} 
              id={collapseOpened2 === 'accordionCollapse2' ? 'blue-text' : ''} 
              className={selectedItem === 'Documents' ? 'blue-background' : ''}>

              <p className="textLItem">Documents</p>

                </MDBSideNavLink> 

              </MDBSideNavCollapse>

                </MDBSideNavItem>
    
              </MDBSideNavMenu>
          
            </div>
          
           <p className="menu__legalsmentions">(C) 2018 All Rights Reserved. This is the "Admin Theme" built with Bootstrap 4, React 16 (latest) & NPM. </p>
           
          </div>

        </MDBSideNav>
  
      </div>
    );
  }

export default Menu